(() => {
  const init = (root = document) => root.querySelectorAll('header-drawer').forEach(drawer => {
    const menu = drawer.querySelector('.koppa-mobile-menu');
    const details = drawer.querySelector('#Details-menu-drawer-container');
    const trigger = details?.querySelector(':scope > summary');
    if (!menu || !trigger || menu.dataset.ready) return;
    menu.dataset.ready = 'true';
    const close = menu.querySelector('[data-kmn-close]');
    let closeTimer = 0;
    const nativeCloseAnimation = drawer.closeAnimation.bind(drawer);
    drawer.closeAnimation = element => {
      if (element !== details) return nativeCloseAnimation(element);
      clearTimeout(closeTimer);
      trigger.setAttribute('aria-expanded', 'false');
      closeTimer = setTimeout(() => {
        closeTimer = 0;
        if (!details.classList.contains('menu-opening')) details.open = false;
      }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180);
    };
    close.addEventListener('click', event => drawer.closeMenuDrawer(event, trigger));
    trigger.addEventListener('click', event => {
      if (!closeTimer) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      clearTimeout(closeTimer);
      closeTimer = 0;
      drawer.openMenuDrawer(trigger);
    }, true);
    let focused = false;
    let focusTimer = 0;
    const observer = new MutationObserver(() => {
      if (!details.open || !details.classList.contains('menu-opening')) { focused = false; clearTimeout(focusTimer); return; }
      if (focused || !matchMedia('(max-width:989px)').matches) return;
      focused = true;
      const focusMenu = () => { if (details.open && details.classList.contains('menu-opening')) { if (typeof trapFocus === 'function') trapFocus(menu, menu.contains(document.activeElement) ? document.activeElement : close); } };
      // Wait for the drawer to become focusable, including the theme's visibility update.
      focusTimer = setTimeout(focusMenu, 190);
    });
    observer.observe(details, {attributes:true,attributeFilter:['open','class']});
    drawer.addEventListener('shopify:section:unload', () => { observer.disconnect(); clearTimeout(closeTimer); clearTimeout(focusTimer); }, {once:true});
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
